module.exports = __webpack_public_path__ + "assets/images/project/head/Okka_Phyo_Maung.jpg?v=9e5aeb5c";